export enum CONTENT_TEMPLATES {
    /**
     * @value Templates
     */
    ADMIN_TEMPLATE = 'ADMIN_TEMPLATE',
    /**
     * @value Content deleted successfully
     */
    DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS',
    /**
     * @value No templates yet
     * @description Message to be displayed in an empty state to notify the user that there's no template that has been added yet
     */
    EMPTY_STATE_TITLE = 'BROADCAST_TEMPLATES.EMPTY_STATE_TITLE',
    /**
     * @value Remove the template
     */
    TEMPLATE_DELETE = 'TEMPLATE_DELETE',
    /**
     * @value Are you sure you want to delete this template?
     */
    TEMPLATE_DELETE_DESCRIPTION = 'TEMPLATE_DELETE_DESCRIPTION',
}
